<script lang="ts">
    // import { getContext } from 'svelte'
    import Icon from '@iconify/svelte'
    // import type { HydriaDocument } from 'hydria/HydriaDocument'
    // import MdeEditor from 'hydria/components/MdeEditor.svelte'
    import Modal from 'hydria/components/Modal.svelte'
    // import TipTap from 'hydria/components/TipTapGen/index.svelte'
    import { type TGettext, gettext as _, resolve, tgettext } from 'hydria/services/gettext'

    import CodeMirror from 'admin/components/CodeMirror.svelte'
    import { onMount } from 'svelte'

    // const Document = getContext('Document') as HydriaDocument

    interface Props {
        saved: string
        value: string
        disabled?: boolean
        showLabel?: boolean
        label?: any
        helpText?: TGettext | 'default'
        isValid?: any
        save?: (v: string) => void
    }

    let { saved: savedValue, value: currentValue = $bindable(), disabled = false, showLabel = true, label = tgettext('Introduction'), helpText = $bindable('default'), isValid = (value: string) => true, save }: Props = $props()

    let value: string = $state('')

    function load(currentValue: string) {
        if (value !== currentValue) value = currentValue
    }

    if (helpText === 'default') helpText = tgettext('Ce texte est affiché au début de la page. Ne pas oublier d’y inclure le titre principal.')

    let savedIsValid = isValid(savedValue)
    let isOpen = $state(false)

    function keep() {
        currentValue = value
        if (save) save(currentValue)
        close()
    }

    function open() {
        load(currentValue)
        isOpen = true
    }
    function close() {
        load(currentValue)
        isOpen = false
    }
    onMount(() => {
        load(currentValue)
    })
    let isPristine = $derived(currentValue === savedValue)
    let statusIcon: string = $derived(isPristine ? (savedIsValid ? 'mdi:check-circle' : 'mdi:alert') : isValid(currentValue) ? 'mdi:undo' : 'mdi:undo')
    let statusClass: string = $derived(isPristine ? (savedIsValid ? 'btn-link' : 'btn-danger') : isValid(currentValue) ? 'btn-outline-warning' : 'btn-outline-danger')
</script>

<div class="row g-3 align-items-baseline">
    {#if showLabel}
        <div class="col-2 text-end"><label aria-hidden="true" for="nothing" class="control-label" onclick={() => open()}>{$resolve(label)}</label></div>
    {/if}
    <div class="col">
        {#if isOpen}
            <Modal close={() => close()} keep={() => keep()} modalClasses="modal-xl">
                <div class="modal-header text-bg-primary">{$resolve(label)}</div>
                <div class="modal-body">
                    <CodeMirror options={{ theme: 'ttcn', lineWrapping: true, lineNumbers: true, readOnly: false }} bind:value />
                    {#if helpText != null}
                        <div class="form-text">{$resolve(helpText)}</div>
                    {/if}
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-outline-secondary" onclick={() => close()}>{$_('Fermer')}</button>
                    <button type="button" class="btn btn-sm btn-primary" disabled={!isValid(value) || value === currentValue} onclick={() => keep()}>{$_('Appliquer')}</button>
                </div>
            </Modal>
        {/if}
        <div aria-hidden="true" ondblclick={() => open()} style="overflow: hidden">
            {#if currentValue && currentValue != ''}
                <pre style="overflow: auto hidden;">{currentValue}</pre>
            {:else}
                <em class="text-muted">{$_('non-configuré')}</em>
            {/if}
        </div>
        {#if helpText != null}
            <div class="form-text">{$resolve(helpText)}</div>
        {/if}
    </div>
    <div class="col-auto text-end">
        <button
            type="button"
            class="btn btn-sm {statusClass}"
            disabled={isPristine}
            onclick={() => {
                currentValue = savedValue
            }}><Icon inline icon={statusIcon} /></button
        >
        <button type="button" class="btn btn-sm btn-outline-secondary" {disabled} onclick={() => open()}><Icon inline icon="mdi:edit" /></button>
    </div>
</div>
